import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourRecetReferencias: TourDefinicion = {
  codigo: 'recet-referencias',
  titulo: 'Referencias',
  descripcion: 'Catálogo central de referencias bibliográficas.',
  ruta: '/admin/recet/referencias',
  permisoMenu: Permisos.REFERENCIAS_MENU,
  pasos: [
    {
      id: 'recet-referencias:header',
      selector: '[data-testid="recet-referencias.header"]',
      titulo: 'Referencias bibliográficas',
      descripcion:
        'Administra el catálogo compartido de referencias que luego podrás asociar a cualquier tecnología.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'recet-referencias:boton-crear',
      selector: '[data-testid="recet-referencias.boton-crear"]',
      titulo: 'Nueva referencia',
      descripcion:
        'Registra una referencia con sus autores, año y enlace. Queda disponible para todas las tecnologías.',
      permisoRequerido: Permisos.REFERENCIAS_CREAR,
      side: 'left',
      align: 'center',
    },
    {
      id: 'recet-referencias:tabla',
      selector: '[data-testid="recet-referencias.tabla"]',
      titulo: 'Listado',
      descripcion:
        'Edita, elimina o asocia a tecnologías cada referencia desde las acciones de la fila.',
      side: 'top',
      align: 'center',
    },
  ],
};
